module.exports = __webpack_public_path__ + "img/code-2021-7-2.4f7753ac.png";